<template>
	<div>
		<br />
		<div style="text-align:left;">
			<router-link to="/adminhome">< Home</router-link>
		</div>

		<br />
		<div class="row my-2">
			<select class="form-control col-md-2 mx-1" v-model="filter.ministryRole">
				<option disabled selected>Filter by Ministry Role</option>
				<option v-for="role in ministryRoles" v-bind:value="role.id">{{ role.name }}</option>
			</select>
			<select class="form-control col-md-2 mx-1" v-model="filter.status">
				<option disabled selected>Filter by Status</option>
				<option value="All">All</option>
				<option v-for="status in statusOptions" v-bind:value="status">{{ status }}</option>
			</select>

			<select v-model="filter.centre" class="form-control col-md-2 mx-1">
				<option disabled selected>Filter by Centre</option>
				<option value="All">All</option>
				<option v-for="centre in centreOptions" v-bind:value="centre">{{ centre }}</option>
			</select>
			<select v-model="filter.congregation" class="form-control col-md-2 mx-1">
				<option disabled selected>Filter by Congregation</option>
				<option value="All">All</option>
				<option
					v-for="congregation in congregationOptions"
					v-bind:value="congregation"
				>{{ congregation }}
				</option>
			</select>
		</div>
		<div class="row">
			<input
				type="text"
				class="form-control col-md-2 mx-1"
				v-model="filter.candidateName"
				placeholder="Applicant's Name"
			/>
			<input
				type="text"
				class="form-control col-md-2 mx-1"
				v-model="filter.approverName"
				placeholder="Approver's Name"
			/>
			<button class="btn btn-primary ml-1" v-on:click="getMinistryRequests(false)">Search</button>
			<button class="btn btn-default" v-on:click="clearFilters">Clear All</button>
		</div>

		<paginate
			v-show="pagination.totalCount > 0"
			v-model="pagination.currentPage"
			:page-count="pagination.totalCount / pagination.noPerPage"
			:prev-text="'Previous'"
			:next-text="'Next'"
			:click-handler="handlePaginate"
			:container-class="'pagination'"
			:page-class="'page-item'"
			:active-class="'page-active'"
		></paginate>

		<div class="row my-2">
			<button
				class="btn btn-info col-md-1 mx-1"
				:disabled="selectedIds.length === 0"
				data-toggle="modal"
				data-target="#dmModal"
				v-on:click="promptDmModal"
			>
				<i class="fas fa-envelope"></i> Send Message
			</button>
			<button class='btn btn-success col-md-1 mx-1' :disabled="filter.ministryRole === 'Filter by Ministry Role'" v-on:click="goToMLSignUp">New Sign Up</button>
			<span class="noLG col-md-1 pt-2 mx-1">No Life Group</span>
			<span class="col-md-2 pt-3 my-1">
        <i>Showing {{ ministryRequests.length }} per page</i>
      </span>
		</div>
		<table class="table table-stripe table-hover">
			<thead>
				<th>
					<input type="checkbox" v-model="all" v-on:click="selectAll" id="all" />
					<label for="all">ID #</label>
				</th>
				<th>Applied For</th>
				<th>Applicant</th>
				<th>Congregation</th>
				<th>Approver</th>
				<th>Status</th>
				<th>Signed Up On</th>
				<th>Direct Message</th>
			</thead>
			<tbody>
				<tr v-show="ministryRequests.length == 0">
					<td colspan="7" style="text-align:left;">No data available</td>
				</tr>
				<tr v-for="mr in ministryRequests" v-bind:class="{'noLG':mr.noLG}">
					<td>
						<input :id="mr.id" type="checkbox" :value="mr.id" v-model="selectedIds" />
						<label :for="mr.id">{{ mr.id }}</label>
					</td>
					<td>
						{{ mr.ministryRole.name }} in {{ mr.ministryRole.department }}
						<br />Requirement:
						<span v-if="mr.ministryRole.requirement == 1">Step A</span>
						<span v-if="mr.ministryRole.requirement == 2">Step B</span>
						<span v-if="mr.ministryRole.requirement == 3">Step C</span>
						<span v-if="mr.ministryRole.requirement == 4">Step D</span>
					</td>
					<td>
						{{ mr.candidateName }}
						<br />
						{{ mr.candidateMobile }}
						<br />
						{{ mr.candidateEmail }}
					</td>
					<td>{{ mr.congregation }}</td>
					<td>
            <span v-show="!mr.noLG">
              {{ mr.approverName }}
              <br />
              {{ mr.approverMobile }}
              <br />
              {{ mr.approverEmail }}
              <br />
              <button
	              class="btn btn-default"
	              data-toggle="modal"
	              data-target="#updateApproverModal"
	              v-on:click="setApproverCurrentMr(mr)"
              >
                <i class="fas fa-edit"></i>
              </button>
              <button class="btn btn-link" v-on:click="resendApproval(mr.id)">Notify Approver</button>
            </span>
						<span v-show="mr.noLG">No Life Groups</span>
					</td>
					<td>
						{{ mr.status }}
						<span v-show="mr.status === 'Rejected by Leader'">
              <br />
              on
              {{ mr.approvalReceived | moment("DD MMM YY") }}
              <br />
              <i>{{ mr.approvalReceived | moment("from", "now", true) }} ago</i>
              <br />
            </span>
						<button
							class="btn btn-default"
							data-toggle="modal"
							data-target="#updateMrModal"
							v-on:click="openUpdateModal(mr)"
						>
							<i class="fas fa-edit"></i>
						</button>

						<button
							data-toggle="modal"
							data-target="#remarksModal"
							v-on:click="setRemarks(mr.remarks)"
							v-show="mr.remarks"
							class="btn btn-default"
						>
							<i class="fas fa-envelope"></i>
						</button>
					</td>
					<td>
						{{ mr.createdAt | moment("DD MMM YY") }}
						<br />
						<i>{{ mr.createdAt | moment("from", "now", true) }} ago</i>
					</td>
					<td>
						<button
							class="btn btn-link"
							data-toggle="modal"
							data-target="#dmInfoModal"
							v-on:click="promptDmInfoModal(mr)"
						>{{ mr.directMessages.length }} DMs
						</button>
					</td>
				</tr>
			</tbody>
		</table>
		<paginate
			v-show="pagination.totalCount > 0"
			v-model="pagination.currentPage"
			:page-count="pagination.totalCount / pagination.noPerPage"
			:prev-text="'Previous'"
			:next-text="'Next'"
			:click-handler="handlePaginate"
			:container-class="'pagination'"
			:page-class="'page-item'"
			:active-class="'page-active'"
		></paginate>
		<!-- Modals -->

		<div
			class="modal fade"
			id="dmModal"
			tabindex="-1"
			role="dialog"
			aria-labelledby="exampleModalLabel"
			aria-hidden="true"
		>
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5>Enter Message</h5>
					</div>
					<div class="modal-body">
						<div class="alert alert-danger" v-show="dmErrorMessage.length > 0">{{ dmErrorMessage }}</div>

						<div class="row">
							<p class="ml-4">Dear [recipients],</p>
							<div class="form-group col-md-12 col-xs-12">
								<div class="alert alert-success" v-show="dmResponse">{{ dmResponse }}</div>
								<textarea
									rows="10"
									class="form-control"
									v-model="dmMessage"
									placeholder="Enter your message"
								></textarea>
							</div>
							<p class="ml-4">
								<input type="checkbox" v-model="messageTemplate.showContact" id="dmContactMe" />
								<label for="dmContactMe">Please contact me at</label>&nbsp;
								<input
									type="text"
									v-model="messageTemplate.contact"
									placeholder="Enter email or mobile"
								/>
							</p>
							<p class="ml-4">
								<input type="checkbox" v-model="dmChangeStatusCheck" id="dmChangeStatusCheck" />
								<label for="dmChangeStatusCheck">Update Status To</label> &nbsp;
								<select v-model="dmChangeStatusTo" class>
									<option disabled value>Select Status</option>
									<option v-for="status in statusOptions" v-bind:value="status">{{ status }}</option>
								</select>
							</p>
						</div>
					</div>
					<div class="modal-footer">
						<button class="btn btn-danger" v-on:click="insertDeclineMessage">Insert Decline Message</button>
						<button
							class="btn btn-primary"
							v-on:click="createDirectMessage"
							:disabled="dmResponse.length>0 || dmErrorMessage.length > 0"
						>Send
						</button>
					</div>
				</div>
			</div>
		</div>
		<div
			class="modal fade"
			id="remarksModal"
			tabindex="-1"
			role="dialog"
			aria-labelledby="exampleModalLabel"
			aria-hidden="true"
		>
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-body">{{ selectedRemarks }}</div>
				</div>
			</div>
		</div>

		<div
			class="modal fade"
			id="dmInfoModal"
			tabindex="-1"
			role="dialog"
			aria-labelledby="exampleModalLabel"
			aria-hidden="true"
		>
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-body">
						Message Sent: {{ selectedDm.message }}
						<br />
						<br />
						<div v-for="dm in displayDms">
							<b>{{ dm.createdAt | moment("DD MMM YY, HH:mma") }}</b>
							<p>{{ dm.message }}</p>
						</div>
						<div v-show="displayDms.length == 0">
							<i>No DM sent</i>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div
			class="modal fade"
			id="updateApproverModal"
			tabindex="-1"
			role="dialog"
			aria-labelledby="exampleModalLabel"
			aria-hidden="true"
		>
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5>Search for Approver</h5>
					</div>
					<div class="modal-body">
						<div class="alert alert-success" v-show="searchApprover.success">Updated Approver</div>
						<div>
							<div class="form-group">
								<input
									type="text"
									v-on:keyup="performApproverSearch"
									class="form-control"
									v-model="searchApprover.searchTerm"
									placeholder="Enter Approver's Name"
								/>
								<div v-for="a in searchApprover.results">
									{{ a.displayName }} | {{ a.mobile }}
									<button v-on:click="selectApprover(a)" class="btn btn-link btn-sm">Select</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div
			class="modal fade"
			id="updateMrModal"
			tabindex="-1"
			role="dialog"
			aria-labelledby="exampleModalLabel"
			aria-hidden="true"
		>
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5>Update Ministry Request ID #{{ selectedMr.id }}</h5>
					</div>
					<div class="modal-body">
						<div class="alert alert-success" v-show="updateOk">{{ updateOk }}</div>
						<div class="alert alert-danger" v-show="updateErr">{{ updateErr }}</div>
						<div>
							<div class="form-group">
								<label>Change Status</label>
								<select class="form-control" v-model="modalMrSelection.status">
									<option v-for="status in statusOptions" v-bind:value="status">{{ status }}</option>
								</select>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button
							v-on:click="submitUpdate"
							class="btn btn-primary"
							:disabled="updateOk.length > 0"
						>Submit
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import http from "../commons/http.js";
import config from "../config.js";

export default {
	data:        function () {
		return {
			congregationOptions: config.congregationOptions,
			centreOptions:       config.centreOptions,
			statusOptions:       config.statusOptions,
			ministryRequests:    [],
			ministryRoles:       [],
			selectedRemarks:     "",
			selectedMr:          {},
			modalMrSelection:    {
				status: ""
			},
			updateOk:            "",
			updateErr:           "",
			filterMinistry:      {},
			dmMessage:           "",
			dmChangeStatusTo:    "",
			selectedIds:         [],
			all:                 false,
			dmResponse:          "",
			selectedDm:          {
				status:  "",
				message: ""
			},
			dmErrorMessage:      "",
			dmRsvpRequired:      false,
			filter:              {
				status:       "Filter by Status",
				dmStatus:     "Filter by DM Status",
				ministryRole: "Filter by Ministry Role",
				congregation: "Filter by Congregation",
				centre:       "Filter by Centre"
			},
			pagination:          {
				noPerPage:   20,
				totalCount:  0,
				currentPage: 1
			},
			displayDms:          [],
			messageTemplate:     {
				contact:     "",
				showContact: false
			},
			searchApprover:      {
				currentMr:  {},
				searchTerm: "",
				results:    [],
				success:    false
			},
			newSignUp:           {
				success: false,
				mr:      {}
			}
		};
	},
	methods:     {
		goToMLSignUp:              function () {
			window.open('#/mlsignup?role=' + this.filter.ministryRole, '_blank');
		},
		selectApprover:            async function (approver) {
			this.searchApprover.currentMr.approverName = approver.displayName;
			this.searchApprover.currentMr.approverMobile = approver.mobile;
			this.searchApprover.currentMr.approverEmail = approver.email;

			let data = {
				approverName:   approver.displayName,
				approverMobile: approver.mobile,
				approverEmail:  approver.email
			};

			console.log("data", data);
			try {
				let response = await http.patch(
					"/ministryrequest/" + this.searchApprover.currentMr.id,
					data
				);
				this.searchApprover.success = true;
			} catch (err) {
				console.err("select approver err", err);
			}
		},
		setApproverCurrentMr:      function (currentMr) {
			this.searchApprover.currentMr = currentMr;
			this.searchApprover.success = false;
		},
		performApproverSearch:     async function () {
			try {
				let response = await http.get(
					"/structure/search?name=" + this.searchApprover.searchTerm
				);
				this.searchApprover.results = response.data;
			} catch (err) {
				console.error("search approver err", err);
			}
		},
		handlePaginate:            function (pageNum) {
			this.pagination.currentPage = pageNum;
			this.getMinistryRequests(true);
		},
		insertDeclineMessage:      function () {
			let mr = {};

			for (let i = 0; i < this.ministryRoles.length; i++) {
				let role = this.ministryRoles[ i ];
				if (role.id === this.filter.ministryRole) {
					mr = role;
				}
			}

			let rejection =
				    "Thank you for responding to Contribute! There have been some concerns raised by your pastoral leader regarding your recent application to serve in/as a " +
				    mr.name +
				    " of " +
				    mr.department +
				    " Department. If you have not heard from them, please do speak to them!\n\nPlease ignore the message if you have spoken to your Pastoral leader.\n\nShould you want to join a new ministry or re-apply after speaking to your leaders, click here: https://www.hopesingapore.org.sg/contributeroles/";
			if (this.dmMessage.length > 0) {
				if (confirm("You will lose your composed message. Proceed?")) {
					this.dmMessage = rejection;
				}
			} else {
				this.dmMessage = rejection;
			}
		},
		selectAll:                 function () {
			if (!this.all) {
				this.selectedIds = [];
				let selected = [];
				this.ministryRequests.forEach(mr => {
					selected.push(mr.id);
				});
				this.selectedIds = selected;
			} else {
				this.selectedIds = [];
			}
		},
		setRemarks:                function (remarks) {
			if (typeof remarks === "undefined" || remarks == "") {
				this.selectedRemarks = "<No remarks given by approval person>";
			} else {
				this.selectedRemarks = remarks;
			}
		},
		getMinistryRequests:       async function (changePage) {
			let url = "/ministryrequest?populate=directMessages,ministryRole";
			if (!changePage) {
				this.pagination.currentPage = 1;
			}
			// delete non filter
			let queryFilter = _.clone(this.filter);

			for (var key in queryFilter) {
				queryFilter[ key ] = queryFilter[ key ].toString();

				if (
					queryFilter[ key ].toLowerCase().includes("filter") ||
					queryFilter[ key ].toLowerCase().includes("all") ||
					queryFilter[ key ].length === 0
				) {
					delete queryFilter[ key ];
				}
			}
			if (JSON.stringify(queryFilter) === "{}") {
				alert("Search parameters cannot be empty.");
				return;
			}

			let whereQuery = JSON.stringify(queryFilter);
			if (!whereQuery.includes("ministryRole")) {
				alert("Filter by Ministry Role is required");
				return;
			}
			url += "&where=" + whereQuery;
			url += "&sort=createdAt DESC";
			let limit = this.pagination.noPerPage;
			let skip = 0;
			if (this.pagination.currentPage > 1) {
				skip = (this.pagination.currentPage - 1) * this.pagination.noPerPage;
			}

			url += "&limit=" + limit;
			url += "&skip=" + skip;

			let response = await http.get(url);

			if (response.status == 200) {
				response.data.forEach(mr => {
					if (mr.directMessage == null) {
						mr.directMessage = {
							status:       "",
							rsvpRequired: false
						};
					}
				});
				this.ministryRequests = response.data;
				console.log("changePage", changePage);
			}

			try {
				let countResp = await http.get(
					"/ministryrequest/count?where=" + whereQuery
				);
				this.pagination.totalCount = countResp.data;
			} catch (err) {
				console.error("mr count err", err);
			}
		},
		resendApproval:            async function (id) {
			try {
				var response = await http.post("/ministryrequest/send", { id: id });
				alert("Resend successful!");
			} catch (err) {
				alert("Unable to resend. Please try again.");
			}
		},
		openUpdateModal:           async function (mr) {
			this.selectedMr = mr;
			this.modalMrSelection.status = mr.status;
			this.updateOk = "";
			this.updateErr = "";
		},
		submitUpdate:              async function () {
			this.updateOk = "";
			this.updateErr = "";

			try {
				var response = await http.patch(
					"/ministryrequest/" + this.selectedMr.id,
					this.modalMrSelection
				);
				this.updateOk = "Update successful!";
				this.selectedMr.status = this.modalMrSelection.status;
			} catch (err) {
				this.updateErr = "There is an error. Please try again.";
			}
		},
		getPermittedMinistryRoles: async function () {
			try {
				let response = await http.get("/ministryrolepermission/get");
				this.ministryRoles = response.data;
			} catch (err) {
				alert(
					"An unexpected error encountered. Please refresh the page and try again."
				);
			}
		},

		promptDmModal: function () {
			this.dmResponse = "";
			this.dmMessage = "";
			this.dmRsvpRequired = false;
		},

		createDirectMessage: async function () {
			let message = this.dmMessage;
			let lastChar = message[ message.length - 1 ];
			if (lastChar !== ".") {
				message += ".";
			}
			if (this.messageTemplate.showContact) {
				let prefix = "tel:";
				if (this.messageTemplate.contact.includes("@")) {
					prefix = "mailto:";
				}
				message +=
					"\n\nPlease contact me at <a href='" +
					prefix +
					this.messageTemplate.contact +
					"'>" +
					this.messageTemplate.contact +
					"</a>";
			}

			let postData = {
				message:          message,
				rsvpRequired:     this.dmRsvpRequired,
				ministryRequests: this.selectedIds
			};
			if (this.dmChangeStatusCheck) {
				postData.changeStatusTo = this.dmChangeStatusTo;
			}
			try {
				let response = await http.post("/directmessage/create", postData);
				this.dmResponse = "You have successfully ";
				if (response.data.created.length > 0) {
					this.dmResponse +=
						"created " + response.data.created.length + " new DM(s)";
				}
				if (
					response.data.created.length > 0 &&
					response.data.updated.length > 0
				) {
					this.dmResponse +=
						" and updated " + response.data.updated.length + " existing DM(s)";
				}
				if (response.data.updated.length > 0 && response.data.created === 0) {
					this.dmResponse +=
						"updated " + response.data.updated.length + " existing DM(s)";
				}

				this.getMinistryRequests(false);
			} catch (err) {
				alert("An unexpected error encountered. Please try again.");
				console.log("create dm error", err);
			}
		},

		promptDmInfoModal: function (mr) {
			this.displayDms = mr.directMessages;
		},

		setSelectedDirectMessage: function (dm) {
			this.selectedDm = dm;
		},

		clearFilters: function () {
			(this.filter = {
				status:       "Filter by Status",
				dmStatus:     "Filter by DM Status",
				ministryRole: "Filter by Ministry Role"
			}),
				(this.ministryRequests = []);
		}
	},
	beforeMount: async function () {
		this.getPermittedMinistryRoles();
		if (!(await http.isLoggedIn())) {
			this.$router.push("/adminlogin");
		}
	}
};
</script>

<style>
.pagination {
	margin-left : 10px;
}

.page-item {
	margin-left  : 10px;
	margin-right : 10px;
}

.page-active {
	font-weight     : bold;
	text-decoration : underline;
}

.noLG {
	background-color : orange;
}
</style>
